<template>
    <div class="notice-page px-4 py-4 md:px-5">
        <div class="mx-auto space-y-5">
            <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div class="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
                    <div>
                        <p class="text-[15px] font-semibold text-slate-900">공지사항 관리</p>
                        <p class="mt-1 text-sm text-slate-500">사이트 공지사항을 등록, 확인, 삭제할 수 있습니다.</p>
                    </div>
                </div>
            </section>

            <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div class="mb-4 flex flex-col gap-3 border-b border-slate-200 pb-4 md:flex-row md:items-center md:justify-between">
                    <div>
                        <p class="text-base font-semibold text-slate-900">공지사항 목록</p>
                        <p class="mt-1 text-sm text-slate-500">총 {{ notiListPage.totalCnt }}건</p>
                    </div>
                    <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
                        <div class="flex flex-wrap gap-2 text-sm text-slate-500">
                            <span class="result-chip">페이지 {{ notiListPage.searchParams.pageNum }}</span>
                            <span class="result-chip">선택 {{ notiListPage.selectedCheckboxes.length }}건</span>
                        </div>
                        <div class="flex flex-col gap-3 sm:flex-row">
                            <button
                                type="button"
                                class="primary-button"
                                @click="
                                    notiListPage.registNoti(
                                        notiListPage.searchParams.idxLeSiteMain
                                    )
                                "
                            >
                                등록
                            </button>
                            <button type="button" class="danger-button" @click="notiListPage.deleteNotice">
                                삭제
                            </button>
                        </div>
                    </div>
                </div>

                <div class="table-scroll-wrap rounded-xl border border-slate-200">
                    <BagicTable
                        :header="notiListPage.tableHeader"
                        :list="notiListPage.noticeList"
                        :pageSize="notiListPage.searchParams.pageSize"
                        :totalRows="notiListPage.totalCnt"
                        :enableCheckBox="true"
                        :checkParamName="notiListPage.checkParamName"
                        @paging-click="notiListPage.movePage"
                        @check-click="notiListPage.checkBoxClick"
                    >
                    </BagicTable>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import { onMounted, reactive, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import axios from "@/plugins/axios.js";
import BagicTable from "@/components/BagicTable.vue";

export default {
    components: {
        BagicTable,
    },
    setup() {
        const router = useRouter();
        const route = useRoute();

        const notiListPage = reactive({
            searchParams: {
                content: "",
                createDate: "",
                idxLeSiteMain: "",
                rowNum: "",
                staffName: "",
                title: "",
                viewCount: "",
                pageNum: 1,
                pageSize: 50,
            },
            tableHeader: {
                rowNum: "No",
                createDate: "작성일자",
                title: "공지사항 제목",
                staffName: "작성자",
                viewCount: "조회수",
            },
            noticeList: [],
            totalCnt: 0,

            selectedCheckboxes: [],

            checkParamName: "rowNum",

            // 리스트 조회 및 검색
            getNoticeList() {
                notiListPage.searchParams.idxLeSiteMain = parseInt(
                    route.query.idxLeSiteMain
                );
                axios
                    .get("/admin/noticeList", {
                        params: notiListPage.searchParams,
                    })
                    .then(function (res) {
                        if (res.data.success) {
                            notiListPage.totalCnt = res.data.data.totalCnt;
                            notiListPage.noticeList = res.data.data.noticeList;
                            if (Array.isArray(notiListPage.noticeList)) {
                                notiListPage.noticeList.forEach(function (
                                    item
                                ) {
                                    // company
                                    item.title = `<u><a href="/noticeCreate?idxNotice=${item.idxNotice}">${item.title}</a></u>`;
                                });
                            }
                        } else {
                            //alert(res.data.message);
                        }
                        // notiListPage.is_loader = false;
                    });
            },

            // deleteNotice() {
            //     const idxNotice = notiListPage.noticeList[0].idxNotice;

            //     if (confirm("공지사항을 삭제하시겠습니까?")) {
            //         axios
            //             .delete(`/admin/notice?idxNotice=${idxNotice}`, {})
            //             .then((res) => {
            //                 if (res.data.success) {
            //                     notiListPage.getNoticeList();
            //                 }
            //             });
            //     } else {
            //         // 취소 얼럿
            //     }
            // },

            checkBoxClick(selectedCheckboxes) {
                // 선택된 체크박스 정보를 상태에 저장
                notiListPage.selectedCheckboxes = selectedCheckboxes;
            },

            deleteNotice() {
                const selectedNotices = notiListPage.noticeList.filter(
                    (notice) =>
                        notiListPage.selectedCheckboxes.includes(
                            notice[notiListPage.checkParamName]
                        )
                );

                if (selectedNotices.length === 0) {
                    alert("선택된 항목이 없습니다.");
                    return;
                }

                if (confirm("선택한 공지사항을 삭제하시겠습니까?")) {
                    const idxNoticeList = selectedNotices.map(
                        (notice) => notice.idxNotice
                    );
                    axios
                        .delete(
                            `/admin/notice?idxNotice=${idxNoticeList.join(
                                ","
                            )}`,
                            {}
                        )
                        .then((res) => {
                            if (res.data.success) {
                                notiListPage.getNoticeList();
                            }
                        });
                } else {
                    // 취소 얼럿
                }
            },

            movePage(value) {
                notiListPage.searchParams.pageNum = value;
                notiListPage.getNoticeList();
            },

            registNoti(value) {
                let params = { idxLeSiteMain: value };
                router.push({ path: "/noticeCreate", query: params });
            },
        });

        onMounted(() => {
            notiListPage.searchParams.idxLeSiteMain = parseInt(
                route.query.idxLeSiteMain
            );
            if (
                "idxLeSiteMain" in route.query &&
                route.query.idxLeSiteMain > 0
            ) {
                notiListPage.getNoticeList();
            } else {
                alert("잘못된 접근입니다.");
            }
        });

        return {
            notiListPage,
        };
    },
};
</script>
<style scoped>
.notice-page {
    min-height: 100%;
    background:
        radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
        linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.primary-button,
.danger-button {
  display: inline-flex;
  min-height: 2.875rem;
  align-items: center;
  justify-content: center;
  border: 1px solid currentColor;
  border-radius: 0.75rem;
  padding: 0.7rem 1.1rem;
  font-size: 0.95rem;
  font-weight: 700;
  background: #fff;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.primary-button {
  color: #2563eb;
}

.primary-button:hover {
  background: #f8fafc;
}

.danger-button {
  color: #dc2626;
}

.danger-button:hover {
  background: #f8fafc;
}

.result-chip {
    display: inline-flex;
    align-items: center;
    border-radius: 9999px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    padding: 0.4rem 0.8rem;
}

.table-scroll-wrap {
    max-height: calc(100vh - 260px);
    overflow: auto;
}

:deep(table) {
    margin-bottom: 0;
    table-layout: auto;
}

:deep(thead tr) {
    background: #f8fafc;
}

:deep(th) {
    border-color: #e2e8f0;
    padding: 0.85rem 0.65rem;
    font-size: 0.82rem;
    font-weight: 700;
    color: #334155;
    white-space: nowrap;
}

:deep(td) {
    border-color: #e2e8f0;
    padding: 0.85rem 0.65rem;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #334155;
    background-color: #fff;
    white-space: nowrap;
}

:deep(tbody tr:nth-child(even) td) {
    background-color: #fbfdff;
}

:deep(tbody tr:hover td) {
    background-color: #f8fbff;
}

:deep(td p) {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 2rem;
}

:deep(td a),
:deep(td button) {
    white-space: nowrap;
}

:deep(td a) {
    color: #0369a1;
    font-weight: 700;
    text-decoration: none;
}

:deep(.bg-white.border-t.border-gray-200) {
    border-top: 1px solid #e2e8f0;
    background: #fff;
}

:deep(nav[aria-label="Pagination"]) {
    gap: 0.25rem;
}

:deep(nav[aria-label="Pagination"] > span),
:deep(nav[aria-label="Pagination"] .relative.inline-flex) {
    border-radius: 14px;
}

:deep(nav[aria-label="Pagination"] .z-10) {
    background: #1d4ed8;
    color: #fff;
}

@media (max-width: 1024px) {
    :deep(table) {
        min-width: 900px;
    }
}
</style>
